(function () {
  'use strict';

  var BASE_CURRENCY = 'USD';
  var updateTimer = null;
  var isUpdating = false;

  function getActiveCurrency(cart) {
    return (
      cart && cart.currency
    ) || (
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active
    ) || BASE_CURRENCY;
  }

  function getShopifyCurrencyRate(activeCurrency) {
    if (activeCurrency === BASE_CURRENCY) {
      return 1;
    }

    if (
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active === activeCurrency &&
      window.Shopify.currency.rate &&
      isFinite(Number(window.Shopify.currency.rate))
    ) {
      return Number(window.Shopify.currency.rate);
    }

    return null;
  }

  function getCartUrl() {
    var root = '/';

    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      root = window.Shopify.routes.root;
    }

    return root + 'cart.js';
  }

  function formatMoney(cents, currency) {
    var locale = document.documentElement.lang || navigator.language || 'en-US';
    var amount = Number(cents) / 100;

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2) + ' ' + currency;
    }
  }

  function getProgressPercent(cartTotalCents, thresholdCents) {
    if (!thresholdCents || thresholdCents <= 0) {
      return 0;
    }

    var percentage = cartTotalCents * 100 / thresholdCents;

    if (percentage > 10 && percentage < 100) {
      percentage = percentage - 5;
    } else if (percentage > 100) {
      percentage = 100;
    }

    if (percentage < 0) {
      percentage = 0;
    }

    return percentage;
  }

  function updateContainer(container, cart) {
    if (!container || !cart) return;

    var thresholdUsdCents = Number(container.dataset.freeShippingThresholdUsdCents);
    var messageTemplate = container.dataset.freeShippingMessage || 'Only ||amount|| left for free shipping';
    var successMessage = container.dataset.freeShippingSuccessMessage || "You've got free shipping!";

    if (!thresholdUsdCents || !isFinite(thresholdUsdCents)) {
      return;
    }

    var activeCurrency = getActiveCurrency(cart);
    var rate = getShopifyCurrencyRate(activeCurrency);

    if (!rate) {
      console.warn('[Free shipping bar] Currency rate not found for:', activeCurrency);
      return;
    }

    var thresholdCurrentCents = Math.round(thresholdUsdCents * rate);
    var cartTotalCents = Number(cart.total_price || 0);
    var remainingCents = thresholdCurrentCents - cartTotalCents;

    var textEl = container.querySelector('[data-free-shipping-text]');
    var barEl = container.querySelector('[data-free-shipping-bar]');

    if (textEl) {
      if (remainingCents > 0) {
        textEl.textContent = messageTemplate.replace(
          '||amount||',
          formatMoney(remainingCents, activeCurrency)
        );
      } else {
        textEl.textContent = successMessage;
      }
    }

    if (barEl) {
      var progress = getProgressPercent(cartTotalCents, thresholdCurrentCents);

      barEl.style.width = progress.toFixed(2) + '%';
      barEl.setAttribute('aria-valuenow', Math.round(progress));
    }
  }

  function updateFreeShippingBars() {
    var containers = document.querySelectorAll('[data-free-shipping-container]');

    if (!containers.length || isUpdating) {
      return;
    }

    isUpdating = true;

    fetch(getCartUrl(), {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-free-shipping-container]').forEach(function (container) {
          updateContainer(container, cart);
        });
      })
      .catch(function (error) {
        console.warn('[Free shipping bar] Cart update failed:', error);
      })
      .finally(function () {
        isUpdating = false;
      });
  }

  function scheduleUpdate(delay) {
    clearTimeout(updateTimer);

    updateTimer = setTimeout(function () {
      updateFreeShippingBars();
    }, typeof delay === 'number' ? delay : 100);
  }

  function scheduleUpdateSeries() {
    scheduleUpdate(50);

    setTimeout(updateFreeShippingBars, 250);
    setTimeout(updateFreeShippingBars, 700);
    setTimeout(updateFreeShippingBars, 1400);
  }

  function isCartRequest(input) {
    var url = '';

    if (typeof input === 'string') {
      url = input;
    } else if (input && input.url) {
      url = input.url;
    }

    return /\/cart\/(add|change|update|clear)(\.js)?/i.test(url);
  }

  function patchFetchForCartUpdates() {
    if (window.__freeShippingFetchPatched || typeof window.fetch !== 'function') {
      return;
    }

    window.__freeShippingFetchPatched = true;

    var originalFetch = window.fetch;

    window.fetch = function () {
      var input = arguments[0];
      var shouldUpdate = isCartRequest(input);

      var promise = originalFetch.apply(this, arguments);

      if (shouldUpdate) {
        promise
          .then(function () {
            scheduleUpdateSeries();
          })
          .catch(function () {
            scheduleUpdateSeries();
          });
      }

      return promise;
    };
  }

  function subscribeToThemeCartUpdates() {
    if (typeof window.subscribe !== 'function') {
      return;
    }

    try {
      window.subscribe('cartUpdate', function () {
        scheduleUpdateSeries();
      });

      window.subscribe('quantityUpdate', function () {
        scheduleUpdateSeries();
      });
    } catch (error) {}
  }

  function observeCartDomChanges() {
    if (!document.body || !window.MutationObserver) {
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      var shouldUpdate = false;

      mutations.forEach(function (mutation) {
        if (shouldUpdate) return;

        var target = mutation.target;

        if (
          target &&
          target.nodeType === 1 &&
          (
            target.matches('[data-cart-wrapper], [data-cart-drawer-body], [data-free-shipping-container]') ||
            target.querySelector('[data-cart-wrapper], [data-cart-drawer-body], [data-free-shipping-container]')
          )
        ) {
          shouldUpdate = true;
          return;
        }

        mutation.addedNodes.forEach(function (node) {
          if (shouldUpdate || node.nodeType !== 1) return;

          if (
            node.matches('[data-cart-wrapper], [data-cart-drawer-body], [data-free-shipping-container]') ||
            node.querySelector('[data-cart-wrapper], [data-cart-drawer-body], [data-free-shipping-container]')
          ) {
            shouldUpdate = true;
          }
        });
      });

      if (shouldUpdate) {
        scheduleUpdateSeries();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    patchFetchForCartUpdates();
    subscribeToThemeCartUpdates();
    observeCartDomChanges();
    scheduleUpdateSeries();
  });

  window.addEventListener('load', function () {
    scheduleUpdateSeries();
  });

  document.addEventListener('cart:update', scheduleUpdateSeries);
  document.addEventListener('cart:updated', scheduleUpdateSeries);
  document.addEventListener('cart:change', scheduleUpdateSeries);
  document.addEventListener('cart:refresh', scheduleUpdateSeries);
  document.addEventListener('theme:cart:update', scheduleUpdateSeries);
  document.addEventListener('shopify:section:load', scheduleUpdateSeries);

  document.addEventListener('submit', function (event) {
    if (
      event.target &&
      event.target.matches('form[action*="/cart/add"], form[action*="/cart/add.js"]')
    ) {
      scheduleUpdateSeries();
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (
      event.target.closest('[data-cart-item-remove], [data-quantity-increment], [data-quantity-decrement], #gift_wrap, [data-add-to-cart]')
    ) {
      scheduleUpdateSeries();
    }
  }, true);

  window.updateFreeShippingBars = updateFreeShippingBars;
})();